import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../Config';
import { getReportParams, report } from '../../../middleware/report';

const BannerWithTitle = (props) => {

    useEffect(() => {
        reportDWH({ actionType: 'SupportCenterThirdPage', status: 'Ongoing', messageText: 'SupportCenterThirdPage Displayed' });
    }, []);

    return (
        <div className='banner-with-title-block'>
            <div className='banner'>
                <Image className='banner-web' src={Config.epiBaseUrl + props.iContent.bannerWeb?.expandedValue?.url} />
                <Image className='banner-mobile' src={Config.epiBaseUrl + props.iContent.bannerMobile?.expandedValue?.url} />
            </div>
            {
                props.iContent.title?.value &&
                <div className='title'> {props.iContent.title?.value} </div>
            }
        </div>
    );

    function reportDWH(params) {
        const isAuthenticated = props.loginData?.isFullAuthenticated || props.loginData?.isOtpAuthenticated || props.loginData?.isOtpExtendedAuthenticated || props.loginData?.isSilentOtpAuthenticated;

        let reportParams = getReportParams();
        reportParams.area = 'Support';
        reportParams.subArea = 'SupportCenter';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = params.actionType;
        reportParams.status = params.status;
        reportParams.messageText = params.messageText;
        reportParams.customerName = isAuthenticated ? `${props.loginData?.userDetails?.firstName} ${props.loginData?.userDetails?.lastName}` : '';
        reportParams.email = '';
        reportParams.banId = '';
        reportParams.idNumber = props.loginData?.userDetails?.IDNumber ?? '';
        reportParams.subscriber = props.loginData?.userDetails?.contactNumber ?? '';
        reportParams.param1 = props.iContent.title?.value;
        reportParams.param9 = isAuthenticated ? (props.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי') : ''
        reportParams.param10 = props.loginData?.isFullAuthenticated ? 'לקוח' : props.loginData?.isOtpExtendedAuthenticated ? 'OTP מורחב' : props.loginData?.isOtpAuthenticated ? 'OTP' : '';
        report(reportParams);
    }

};

const mapStateToProps = (state) => {
    return {
        loginData: state.authentication.loginData
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BannerWithTitle);
